import { Button, Grid, Input, ListSubheader, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { AudioFileClient, ExtensionClient, MenuClient, PhoneNumberClient, RuleClient, RuleUI } from '../../api/server';
import RuleItems from './RuleItems';
import { useNavigate, useParams } from 'react-router-dom';
import { ExtendedClient } from '../../api/ExtendedClient';

export default function EditRule() {
  const globalInfo = useSelector((state) => state.globalInfo)

  let { currentRuleId } = useParams();
  const navigate = useNavigate();

  const [ruleItems, setRuleItems] = useState("[]");

  const [ruleName, setRuleName] = useState("");
  const [ruleTrigger, setRuleTrigger] = useState("0")
  const [ruleAction, setRuleAction] = useState("0")

  const [callerId, setCallerId] = useState("")

  const [ruleActionDefault, setRuleActionDefault] = useState("0")
  const [ruleActionDefaultValue, setRuleActionDefaultValue] = useState("{}")

  const [addRuleMode, setAddRuleMode] = useState(true);

  const [actions, setActions] = useState([]);
  const [phoneNumbers, setPhoneNumbers] = useState([]);

  const [action, setAction] = useState({ "action": "DONOTHING", "objectId": "" });
  const [action2, setAction2] = useState({ "action": "DONOTHING", "objectId": "" });

  function onActionChange(e) {
    var temp = { ...action };
    temp.action = JSON.parse(e.target.value).action
    temp.objectId = JSON.parse(e.target.value).objectId

    setAction(temp);
  }


  function onAction2Change(e) {
    var temp = { ...action2 };
    temp.action = JSON.parse(e.target.value).action
    temp.objectId = JSON.parse(e.target.value).objectId
    temp.display = getActionName(temp)

    setAction2(temp);
  }

  function getActionName(action) {

    var final = ((actions)).filter((item) => {
      return JSON.stringify({ action: action.action, objectId: action.objectId }) === JSON.stringify({ action: item.action, objectId: item.objectId })
    })[0]?.name;

    console.log(final)

    if (final) {
      return final;
    }
    else {
      return "Do Nothing"
    }
  }

  function reload() {
    const client = (new ExtendedClient(RuleClient)).getClient();

    if (currentRuleId) {

      client.getRuleById(currentRuleId).then((ruleData) => {
        setRuleItems(ruleData.ruleItems)
        setRuleName(ruleData.ruleName)
        setRuleActionDefault(ruleData.defaultRuleAction);
        setRuleActionDefaultValue(getRuleActionDefaultValue(ruleData.defaultRuleAction));
      })
    } else {
      setAddRuleMode(true)
    }
  }


  function onClose() {
    navigate("/rules")
  }

  function isFormInValid() {
    if (ruleName && ruleActionDefaultValue !== "{}" && ruleTrigger === "0" && ruleAction === "0") {
      return false;
    }



    return true;
  }

  function addRuleItem() {

    var ruleActionObject = JSON.parse(ruleAction);
    var ruleTriggerObject = JSON.parse(ruleTrigger);

    if (ruleTriggerObject.name === "MatchCallerId") {
      ruleTriggerObject.objectId = callerId
      ruleTriggerObject.display = "When Caller's Phone Number Is " + callerId
    }

    var ruleItemsObject = { "Trigger": { "Name": ruleTriggerObject.name, "Value": ruleTriggerObject.objectId }, "Action": { "Action": ruleActionObject.action, "ObjectId": ruleActionObject.objectId }, "Display": ruleTriggerObject.display + " " + ruleActionObject.display }

    if (ruleActionObject.action === "PLAYRECORDING") {
      ruleItemsObject.Action.followupAction = action2;
    }


    var tempRuleItems = JSON.parse(ruleItems);

    tempRuleItems.push(ruleItemsObject);

    setRuleItems(JSON.stringify(tempRuleItems));

    setRuleTrigger("0")
    setRuleAction("0")

  }
  function saveRule() {
    const client = (new ExtendedClient(RuleClient)).getClient();

    var ruleUI = new RuleUI();
    ruleUI.ruleItems = ruleItems;
    ruleUI.ruleName = ruleName;
    ruleUI.defaultRuleAction = ruleActionDefault;

    if (currentRuleId) {
      updateRuleInfo(client, currentRuleId, ruleUI)
    }
    else {
      client.addRule(globalInfo.currentCompanyId, ruleName).then((ruleData) => {
        updateRuleInfo(client, ruleData.ruleId, ruleUI)
      })
    }
  }

  function updateRuleInfo(client, ruleId, ruleUI) {
    client.updateRule(ruleId, ruleUI).then(() => {
      client.updateRuleItems(ruleId, ruleUI).then(() => {
        onClose();
      })
    })
  }

  function onDeleteRule(index) {
    var tempRuleItems = JSON.parse(ruleItems);
    tempRuleItems.splice(index, 1)

    setRuleItems(JSON.stringify(tempRuleItems))
  }


  useEffect(() => {

    const client1 = (new ExtendedClient(ExtensionClient)).getClient();
    const client2 = (new ExtendedClient(MenuClient)).getClient();
    const client3 = (new ExtendedClient(RuleClient)).getClient();
    const client4 = (new ExtendedClient(PhoneNumberClient)).getClient();
    const client5 = (new ExtendedClient(AudioFileClient)).getClient();

    Promise.all([
      client1.getExtensions(globalInfo.currentCompanyId),
      client2.getMenus(globalInfo.currentCompanyId),
      client3.getRules(globalInfo.currentCompanyId),
      client4.getPhoneNumbers(globalInfo.currentCompanyId),
      client5.getAudioFiles(globalInfo.currentCompanyId)
    ]).then((data) => {
      var arrActions = [];
      var extensions = data[0];
      var menus = data[1];
      var rules = data[2];
      var phoneNumberData = data[3];
      var audioFiles = data[4]

      setPhoneNumbers(phoneNumberData);

      arrActions.push({ action: "DONOTHING", name: "Do Nothing", objectId: "" })
      arrActions.push({ "section": "-- Extensions --" })
      extensions.forEach(extension => {
        arrActions.push({ name: `Transfer Call To ${extension.name}`, value: `GOTOEXTENSION-${extension.extensionId}`, action: `GOTOEXTENSION`, objectId: extension.extensionId })
      });

      arrActions.push({ "section": "-- Menu Items --" })
      menus.forEach(menu => {
        arrActions.push({ name: "Go To " + menu.menuName, value: `GOTOMENU-${menu.menuId}`, action: `GOTOMENU`, objectId: menu.menuId })
      });

      arrActions.push({ "section": "-- Rules --" })
      rules.forEach(rule => {
        if (rule.ruleId !== currentRuleId) {
          arrActions.push({ name: "Run Rule " + rule.ruleName, value: `EXECUTERULE-${rule.ruleId}`, action: `EXECUTERULE`, objectId: rule.ruleId })
        }
      });

      arrActions.push({ "section": "-- Audio Files --" })
      audioFiles.forEach(audio => {
        arrActions.push({ name: "Play Audio File " + audio.name, value: `PLAYRECORDING-${audio.audioFileId}`, action: `PLAYRECORDING`, objectId: audio.audioFileId })
      });

      arrActions.push({ "section": "-- Other Actions --" })
      arrActions.push({ name: "Hangup", value: "Hangup", action: "HANGUP", objectId: "" })
      arrActions.push({ name: "Transfer To Voicemail", value: "Voicemail", action: "VOICEMAIL", objectId: "" })
      arrActions.push({ name: "Transfer To Voicemail (Skip Greeting)", value: "Voicemail", action: "VOICEMAILSKIPGREETING", objectId: "" })

      setActions(arrActions)

      reload();
    })

    setActions([])
    // eslint-disable-next-line
  }, [globalInfo, currentRuleId])

  function onChange(event, child) {
    var temp = { ...(JSON.parse(event.target.value)), name: child.props.name }

    setRuleActionDefault(JSON.stringify(temp));
    setRuleActionDefaultValue(getRuleActionDefaultValue(JSON.stringify(temp)))

    console.log(ruleAction)
  }

  function getRuleActionDefaultValue(val) {
    if (val === "0") return val;

    var temp = JSON.parse(val)

    var temp2 = { action: temp.action, objectId: temp.objectId };

    return JSON.stringify(temp2);
  }

  function getRuleTriggerName() {
    return JSON.parse(ruleTrigger).name === "MatchCallerId" ? "" : "none"
  }

  return (
    <div style={{ padding: 20 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          Rule Name:<br></br>
          <Input value={ruleName} onChange={(e) => { setRuleName(e.target.value) }}></Input>
          <br></br>

          <hr></hr>
          <h2>Rules</h2>
          {ruleItems && <RuleItems actions={actions} ruleItems={ruleItems} onDeleteRule={onDeleteRule}></RuleItems>}
          <br></br>
          {
            !addRuleMode && <div>
              <Button variant='outlined' onClick={(e) => { setAddRuleMode(true) }}>Add New Rule</Button>
            </div>
          }
          {
            addRuleMode && <div>
              <Select value={ruleTrigger} style={{ width: 400 }} onChange={(e) => { setRuleTrigger(e.target.value); }}>
                <MenuItem key={0} value={"0"}>--Select a Condition --</MenuItem>
                <MenuItem key={"IsNowAHoliday"} value={JSON.stringify({ "display": "When It Is A Holiday", "name": "IsNowAHoliday", "objectId": "" })}>When It Is A Holiday</MenuItem>
                <MenuItem key={"IsBusinessClosed"} value={JSON.stringify({ "display": "When The Business Is Closed", "name": "IsBusinessClosed", "objectId": "" })}>When The Business Is Closed</MenuItem>
                <MenuItem key={"IsBusinessOpen"} value={JSON.stringify({ "display": "When The Business Is Open", "name": "IsBusinessOpen", "objectId": "" })}>When The Business Is Open</MenuItem>
                {
                  phoneNumbers.map((item, index) => {
                    return <MenuItem key={item.phoneNumberId} value={JSON.stringify({ display: `When Phone Number Dialed is ${item.phoneNumberDigits}`, name: "MatchDialedNumber", objectId: item.phoneNumberId })}>When Phone Number Dialed is {item.phoneNumberDigits}</MenuItem>
                  })
                }
                <MenuItem key={"CallerId"} value={JSON.stringify({ "display": "When Caller's Phone Number Is ", "name": "MatchCallerId", "objectId": "" })}>When Caller's Phone Number Is</MenuItem>
                <MenuItem key={"IsTodayAMonday"} value={JSON.stringify({ "display": "When It Is A Monday", "name": "IsTodayAMonday", "objectId": "" })}>When It Is A Monday</MenuItem>
                <MenuItem key={"IsTodayATuesday"} value={JSON.stringify({ "display": "When It Is A Tuesday", "name": "IsTodayATuesday", "objectId": "" })}>When It Is A Tuesday</MenuItem>
                <MenuItem key={"IsTodayAWednesday"} value={JSON.stringify({ "display": "When It Is A Wednesday", "name": "IsTodayAWednesday", "objectId": "" })}>When It Is A Wednesday</MenuItem>
                <MenuItem key={"IsTodayAThursday"} value={JSON.stringify({ "display": "When It Is A Thursday", "name": "IsTodayAThursday", "objectId": "" })}>When It Is A Thursday</MenuItem>
                <MenuItem key={"IsTodayAFriday"} value={JSON.stringify({ "display": "When It Is A Friday", "name": "IsTodayAFriday", "objectId": "" })}>When It Is A Friday</MenuItem>
                <MenuItem key={"IsTodayASaturday"} value={JSON.stringify({ "display": "When It Is A Saturday", "name": "IsTodayASaturday", "objectId": "" })}>When It Is A Saturday</MenuItem>
                <MenuItem key={"IsTodayASunday"} value={JSON.stringify({ "display": "When It Is A Sunday", "name": "IsTodayASunday", "objectId": "" })}>When It Is A Sunday</MenuItem>

              </Select>
              <Input style={{ display: getRuleTriggerName() }} placeholder='Phone Number' value={callerId} onChange={(e) => { setCallerId(e.target.value) }} ></Input>
              &nbsp;&nbsp;
              <Select value={ruleAction} style={{ width: 400 }}
                onChange={(e) => { onActionChange(e); setRuleAction(e.target.value) }}

              >
                <MenuItem key={-1} value={"0"}>--Select an Action --</MenuItem>
                {actions.map((item, index) => {
                  if (item.section) {
                    return <ListSubheader key={index} >{item.section}</ListSubheader>
                  }
                  else {
                    return <MenuItem key={index} value={JSON.stringify({ display: item.name, name: item.name, action: item.action, objectId: item.objectId })}>{item.name}</MenuItem>
                  }


                })}

              </Select>
              {
                action2 && (JSON.parse(ruleAction)).action === "PLAYRECORDING" && actions && actions.length > 0 && <>
                  <>Followup Action </>
                  <Select value={JSON.stringify({ action: action2.action, objectId: action2.objectId })}
                    onChange={(e) => { onAction2Change(e) }}
                    style={{ width: 370 }}>
                    {
                      actions.map((item, index) => {
                        if (item.section) {
                          return <ListSubheader key={index} >{item.section}</ListSubheader>
                        }
                        else {
                          return <MenuItem key={index} value={JSON.stringify({ action: item.action, objectId: item.objectId })}>{item.name}</MenuItem>
                        }
                      })
                    }
                  </Select>
                </>
              }



              &nbsp; &nbsp;
              <Button variant='outlined' disabled={ruleTrigger === "0" || ruleAction === "0" || (ruleTrigger.includes("MatchCallerId") && callerId === "")} onClick={(e) => { addRuleItem() }}>Add</Button>&nbsp;&nbsp;
              <br></br>
            </div>
          }

          <hr></hr>
          Last Priority: When none of the above rules match:&nbsp;
          {
            <>
              <Select value={ruleActionDefaultValue} style={{ width: 400 }} onChange={onChange}>
                <MenuItem key={-1} value={"{}"}>--Select an Action --</MenuItem>
                {actions.map((item, index) => {
                  if (item.section) {
                    return <ListSubheader key={index} >{item.section}</ListSubheader>
                  }
                  else {
                    return <MenuItem key={index} name={item.name} value={JSON.stringify({ action: item.action, objectId: item.objectId })}>{item.name}</MenuItem>
                  }
                })}

              </Select>
            </>
          }
          <br></br>
          <br></br>
          <Button variant='outlined' disabled={isFormInValid()} onClick={() => { saveRule() }}>Save</Button>
          &nbsp;&nbsp;<Button variant='outlined' onClick={() => { onClose() }}>Close</Button>
          {/* {ruleActionDefault}
          <br></br>
          {ruleActionDefaultValue} */}
        </Grid>
      </Grid>
    </div>
  )
}
